import o, { forwardRef as a } from "react";
import { T as i } from "./chunk.CxhJ6_sJ.js";
import { g as n } from "./chunk.BurCwd5X.js";
const l = a(
  (e, t) => /* @__PURE__ */ o.createElement(
    i,
    {
      id: e.id,
      variant: "status",
      label: e.label,
      size: e.size,
      density: e.density,
      severity: e.severity,
      icon: e.icon,
      ref: t,
      onBlur: e.onBlur,
      onFocus: e.onFocus,
      onMouseOver: e.onMouseOver,
      onMouseLeave: e.onMouseLeave,
      ...n(t)
    }
  )
);
export {
  l as S
};
